module.exports = __webpack_public_path__ + "img/20190802132524134.6f7e55be.png";